import {renderSegment} from "./renderSegment";

export function renderSegments(segments, args) {
    return segments.map(segment => renderSegment(segment, args));
}